import React from 'react';
import SkillsExperience from '../components/SkillsExperience';
import { portfolioData } from '../mock';

const SkillsExperiencePage = () => {
  return (
    <div className="pt-20">
      <SkillsExperience data={portfolioData} />
    </div>
  );
};

export default SkillsExperiencePage;